module.exports = __webpack_public_path__ + "static/media/42-1.351aa4fb.mp3";